import axios from 'axios';
import router from '../router';
import store from '../store'
import {
    Notify,
    Alert,
    Loading
} from 'vue-ydui/dist/lib.rem/dialog';
import Qs from 'qs';

axios.defaults.timeout = 5000;
axios.defaults.baseURL = window.g.BASE_URL + "/api/app/public/";
//http request 拦截器
axios.interceptors.request.use(
    // config => {
    //     const cdata = config.data;
    //     config.data = Qs.stringify(cdata);
    //     config.headers = {
    //         'Content-Type': 'application/x-www-form-urlencoded'
    //         // 'header-encrypt-code': store.state.header
    //     }
    //     return config;
    // },
    // err => {
    //     return Promise.reject(err);
    // }
);


//http response 拦截器
axios.interceptors.response.use(
    // response => {
    //     if (response.data.status_code == 200) {
    //         return response;
    //     } else if (response.data.status_code == 705) { // 超出
    //         return response;
    //     } else if (response.data.status_code == 422) { // 参数错误
    //         return Promise.reject(response.data.message)
    //     } else {
    //         Notify({
    //             mes: '错误：' + response.data.message + '(status_code:' + response.data.status_code + ')',
    //             timeout: 5000
    //         });
    //         return Promise.reject(response.data.message)
    //     }

    // },
    // error => {
    //     console.log('错误')
    //     return Promise.reject(error)
    // }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err)
        })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(response => {
                resolve(response.data);
            }).catch(err => {
                reject(err)
            })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.patch(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}